import { DiscountContract, DiscountType } from 'models'

/**
 * priority to IsCombinable first
 */
export const sortIsCombinableOfDiscount = (
    discounts: DiscountContract[],
): DiscountContract[] => {
    let newArr = [...discounts]
    return newArr.sort((a, b) => {
        const ab = a.isCombinable ? 1 : 0
        const bb = b.isCombinable ? 1 : 0

        return bb - ab
    })
}

/**
 * apply percentage first then fix amount
 */
const DiscountTypeOrder: {
    [type: string]: number
} = {
    [DiscountType.Percentage]: 1,
    [DiscountType.FixedAmount]: 2,
    [DiscountType.BuyXGetY]: 3,
    [DiscountType.FutureDiscount]: 4,
}

export const sortDiscountTypeOfDiscount = (
    discounts: DiscountContract[],
): DiscountContract[] => {
    let sortDiscounts = [...discounts]

    return sortDiscounts.sort((a, b) => {
        const aType = a.type
        const bType = b.type
        const aValue = a.value
        const bValue = b.value
        return (
            DiscountTypeOrder[aType!!] - DiscountTypeOrder[bType!!] ||
            bValue!! - aValue!!
        )
    })
}
